
import { Button, Divider, Grid } from '@mui/material';
import React, { useState } from 'react';
import IQACComposition from './iqacComposition';
import Committees from '../manage-committee/committees.page';
import CustomTabs from '../common/customTabs';


const SynizaIQAC = () => {
    const [option, setOption] = useState(null)
    const [selected, setSelected] = useState("composition")
    // let option;
    function onClick(name) {
        console.log("name trust info:", name);
        setSelected(name);
        setOption(getItem(name));
    }

    function getItem(name) {
        switch (name) {
        
            case "composition":
                return <IQACComposition />
            case "committees":
                return <Committees />
            default:
                break;
        }
    }

    function getTabs() {
        return [
           
            {
                name: "composition", label: "IQAC Composition"
            },
            {
                name: "committees", label: "Committees"
            }
        ]
    }


    return (
        <>
            <Grid container columnSpacing={5}>
                {/* {getTabs().map(tab => <Grid item alignItems="center" sm={4}>
                    <Button variant='contained' style={{ textAlign: "center" }} color={tab.name === selected ? 'secondary' : 'default'} onClick={() => onClick(tab.name)}> {tab.label} </Button>
                </Grid>)} */}

                <CustomTabs tabs={getTabs()} selected={selected} onClick={onClick} cols={2} />


            </Grid>
            <br />
            <Divider />
            <br />
            <Grid container item sm={12}>
                {getItem(selected)}
            </Grid>
        </>
    );
}

export default SynizaIQAC;